import { render, staticRenderFns } from "./plan-view-page.vue?vue&type=template&id=0837f203&scoped=true&"
import script from "./plan-view-page.vue?vue&type=script&lang=js&"
export * from "./plan-view-page.vue?vue&type=script&lang=js&"
import style0 from "./plan-view-page.vue?vue&type=style&index=0&id=0837f203&lang=scss&scoped=true&"
import style1 from "./plan-view-page.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./plan-view-page.vue?vue&type=style&index=2&id=0837f203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0837f203",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCarousel,QCarouselSlide,QTabs,QTab,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCarousel,QCarouselSlide,QTabs,QTab,QTabPanels,QTabPanel})
